export default __webpack_public_path__ + "static/media/Scuba1.e25e927e.mp4";